import type { NavLink } from '../@types/app';

export const navLinks: NavLink[] = [
  {
    href: '/industries',
    name: 'INDUSTRIES',
    menuOnly: true,
    submenu: [
      {
        href: '/industries/workpiece-by-industry',
        name: 'Industries we cater',
      },
      {
        href: '/accessories',
        name: 'Accessories',
      },
      {
        href: '/industries/services',
        name: 'Services',
      },
    ],
  },
  {
    href: '/resources',
    name: 'RESOURCES',
    menuOnly: true,
    submenu: [
      { href: '/blogs/1', name: 'Blogs' },
      { href: '/events', name: 'Events' },
      { href: '/case-studies', name: 'Case Studies' },
      { href: '/guides', name: 'Guides' },
      { href: '/whitepaper', name: 'Whitepaper' },
      { href: '/technical-press-news', name: 'Technical Press News' },
      // Hidden for now — keep for later
      // { href: '/faqs', name: 'FAQs' },
    ],
  },
  {
    href: '/about/',
    name: 'ABOUT US',
    submenu: [
      {
        href: '/about/',
        name: 'Our Vision',
      },
      {
        href: '/about/social-responsibility/',
        name: 'Corporate social responsibility',
      },
      {
        href: '/about/managements/',
        name: 'Leadership & Management',
      },
      {
        href: '/about/message-from-cmd/',
        name: 'Message From the CMD',
      },
      {
        href: '/about/quality-standards-and-infrastructure/',
        name: 'Quality Standards & Infrastructure',
      },
    ],
  },
  { href: '/sales-and-services', name: 'SALES & SERVICES' },
  { href: '/contact-us/', name: 'CONTACT US' },
];
